import React, { Component } from "react";
import {
  Box,
  Text,
  Table,
  TableCell,
  TableRow,
  TableHeader,
  TableBody
} from "grommet";
import TaskHeatMap from "./TaskHeatMap";
import WayPointRow from "./WayPointRow";
import TaskItemListRow from "./TaskItemListRow";
import TaskRowContainer from "./TaskRowContainer";

export class TaskInstanceTable extends Component {
  componentDidMount = () => {};

  getDatapoints = taskInstance => {
    let dataPoints = [];
    taskInstance.IoLocLocations.forEach(location => {
      if (location.Latitude !== 0 && location.Latitude !== 18) {
        const dataPoint = new window.google.maps.LatLng(
          location.Latitude,
          location.Longitude
        );
        dataPoints.push(dataPoint);
      } else {
        console.log("was zero");
      }
    });
    return dataPoints;
  };

  getPrettyDateString = dateString => {
    const firstArray = dateString.split("T");
    const timeString = firstArray[1];
    const secondArray = timeString.split("+");
    return secondArray[0];
  };

  getTimeDifference = (startTime, endTime) => {
    const start = new Date(startTime);
    const end = new Date(endTime);
    const difference = new Date(end - start);

    let differenceString = difference.toISOString().substr(11, 8);
    const diffArray = differenceString.split(":");
    if (diffArray[0] === "00") {
      differenceString = diffArray[1] + ":" + diffArray[2];
    }
    return differenceString;
  };

  render() {
    let taskItemCount = 0;
    let wayPointCount = 0;
    const dataPoints = this.getDatapoints(this.props.taskInstance);
    const startTime = this.getPrettyDateString(
      this.props.taskInstance.StartDateTime
    );
    const endTime = this.getPrettyDateString(
      this.props.taskInstance.EndDateTime
    );
    const timeTaken = this.getTimeDifference(
      this.props.taskInstance.StartDateTime,
      this.props.taskInstance.EndDateTime
    );
    const completed = this.props.taskInstance.completed;

    let completedText;
    let statusColor;
    let statusBackgroundColor;
    if (completed) {
      completedText = "Yes";
      statusColor = "green";
      statusBackgroundColor = "#90EE90";
    } else {
      completedText = "No";
      statusColor = "red";
      statusBackgroundColor = "#FFCCCB";
    }
    return (
      <Box
        pad="small"
        margin="small"
        direction="column"
        border={{ color: "grey", size: "xsmall" }}
      >
        <Box
          pad="small"
          margin="small"
          direction="row"
          alignContent="center"
          justify="center"
          border={{ color: "light-6", size: "xsmall", side: "bottom" }}
        >
          <TaskHeatMap
            zoomCorrection={1.06}
            mapId={this.props.taskInstance.Id}
            currentBuilding={this.props.currentBuilding}
            taskInstance={this.props.taskInstance}
            dataPoints={dataPoints}
            height={"230px"}
            width={"230px"}
          ></TaskHeatMap>
          <Box direction="column">
            <Table>
              <TableHeader>
                <TableRow>
                  <TableCell scope="col" border="bottom">
                    Guard Name
                  </TableCell>
                  <TableCell scope="col" border="bottom">
                    Complete?
                  </TableCell>
                </TableRow>
              </TableHeader>
              <TableBody>
                <TableRow>
                  <TableCell scope="col" border="bottom">
                    {this.props.taskInstance.Shift_Gaurd.Gaurd.GaurdFirstName}
                  </TableCell>
                  <TableCell scope="col" border="bottom">
                    <Box background={statusBackgroundColor}>
                      <Text color={statusColor}>{completedText}</Text>
                    </Box>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
            <Table>
              <TableHeader>
                <TableRow>
                  <TableCell scope="col" border="bottom">
                    Task Start Time
                  </TableCell>
                  <TableCell scope="col" border="bottom">
                    Task End Time
                  </TableCell>
                  <TableCell scope="col" border="bottom">
                    Task Total Time
                  </TableCell>
                </TableRow>
              </TableHeader>
              <TableBody>
                <TableRow>
                  <TableCell scope="col" border="bottom">
                    {startTime}
                  </TableCell>
                  <TableCell scope="col" border="bottom">
                    {endTime}
                  </TableCell>
                  <TableCell scope="col" border="bottom">
                    {timeTaken}
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Box>
        </Box>
        <Box>
          {this.props.taskInstance.SubTaskInstances.map(
            (subTaskInstance, index) => {
              if (subTaskInstance.SubTask.SubTaskType === "Waypoint") {
                wayPointCount++;

                const wayPointStartTime = this.getPrettyDateString(
                  subTaskInstance.StartDateTime
                );
                const wayPointEndTime = this.getPrettyDateString(
                  subTaskInstance.EndDateTime
                );
                const wayPointTimeTaken = this.getTimeDifference(
                  subTaskInstance.StartDateTime,
                  subTaskInstance.EndDateTime
                );
                return (
                  <Box
                    margin="small"
                    pad="small"
                    key={index}
                    border={{
                      color: "light-4",
                      size: "xsmall",
                      side: "bottom"
                    }}
                  >
                    <WayPointRow
                      wayPointStartTime={wayPointStartTime}
                      wayPointEndTime={wayPointEndTime}
                      wayPointTimeTaken={wayPointTimeTaken}
                      wayPointCount={wayPointCount - 1}
                      subTaskInstance={subTaskInstance}
                    ></WayPointRow>
                  </Box>
                );
              } else {
                taskItemCount++;
                return (
                  <Box
                    margin="small"
                    pad="small"
                    key={index}
                    border={{
                      color: "light-4",
                      size: "xsmall",
                      side: "bottom"
                    }}
                  >
                    <TaskRowContainer
                      firebase={this.props.firebase}
                      taskItemCount={taskItemCount}
                      subTaskInstance={subTaskInstance}
                    ></TaskRowContainer>
                  </Box>
                );
              }
            }
          )}
        </Box>
      </Box>
    );
  }
}

export default TaskInstanceTable;
